module.exports = __webpack_public_path__ + "static/media/art65.3ea21522.jpg";